// react/jsx-no-undef

import { format } from "date-fns";
import { enGB } from "date-fns/locale";
import { useState } from "react";
import { DateRangePicker } from "react-date-range";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file

const RangePicker = ({ onStatusChange, togglePopover }) => {
  const [state, setState] = useState([
    {
      startDate: undefined,
      endDate: undefined,
      key: "selection",
    },
  ]);

  return (
    <DateRangePicker
      onChange={(item) => {
        const { startDate, endDate } = item.selection;
        setState([item.selection]);
        onStatusChange((prev) => ({
          ...prev,
          startDate: format(new Date(startDate), "dd/MM/yyyy"),
          endDate: format(new Date(endDate), "dd/MM/yyyy"),
        }));
        togglePopover();
      }}
      ranges={state}
      showSelectionPreview={true}
      moveRangeOnFirstSelection={false}
      months={2}
      direction="horizontal"
      preventSnapRefocus={true}
      calendarFocus="backwards"
      locale={enGB}
    />
  );
};

export default RangePicker;
